import {
 AssignmentIndTwoTone,  Biotech,
  ContactMailTwoTone,
  EmailTwoTone,
  ForumTwoTone,
  GroupTwoTone,
  InsertDriveFileTwoTone,
  LockOpenTwoTone,
  ReceiptLongTwoTone,
  ReceiptTwoTone,
  RequestQuoteTwoTone } from '@mui/icons-material';
import type { OverridableComponent, SvgIconTypeMap } from '@mui/material';
import type { ReactNode } from 'react';
import { Subjects } from 'types/subjects';

export interface MenuItem {
  link?: string;
  icon?:
    | ReactNode
    | (OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & {
        muiName: string;
      });
  badge?: string;
  badgeTooltip?: string;
  subject: Subjects;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
  heading: string;
  subject: Subjects;
}

const menuItems: MenuItems[] = [
  // {
  //   heading: 'My-Labrede',
  //   items: [
  //     {
  //       name: 'Financeiro',
  //       icon: BackupTableTwoTone,
  //       link: '/accent-sidebar/register',
  //       items: [
  //         {
  //           name: 'Boletos',
  //           link: 'register/parameter/list',
  //         },
  //         // {
  //         //   name: 'Negociações',
  //         //   link: 'dashboards/products'
  //         // }
  //       ],
  //     },
  //     // {
  //     //   name: 'Mensalidade',
  //     //   icon: SmartToyTwoToneIcon,
  //     //   link: '/accent-sidebar/dashboards',
  //     //   items: [
  //     //     {
  //     //       name: 'Processar Lote',
  //     //       link: 'dashboards/reports'
  //     //     },
  //     //     {
  //     //       name: 'Lote Manual',
  //     //       link: 'dashboards/expenses'
  //     //       // badge: '',
  //     //       // badgeTooltip: 'This is a dot tooltip example'
  //     //     },
  //     //     {
  //     //       name: 'Pesquisa',
  //     //       link: 'dashboards/products'
  //     //     },
  //     //     {
  //     //       name: 'Teste',
  //     //       link: 'management/FormView'
  //     //     }
  //     //     // {
  //     //     //   name: 'Statistics',
  //     //     //   link: 'dashboards/statistics'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Automation',
  //     //     //   link: 'dashboards/automation'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Analytics',
  //     //     //   link: 'dashboards/analytics'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Banking',
  //     //     //   link: 'dashboards/banking'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Commerce',
  //     //     //   link: 'dashboards/commerce'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Crypto',
  //     //     //   link: 'dashboards/crypto'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Finance',
  //     //     //   link: 'dashboards/finance'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Fitness',
  //     //     //   link: 'dashboards/fitness'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Healthcare',
  //     //     //   link: '/accent-sidebar/dashboards/healthcare',
  //     //     //   items: [
  //     //     //     {
  //     //     //       name: 'Doctors',
  //     //     //       link: 'dashboards/healthcare/doctor'
  //     //     //     },
  //     //     //     {
  //     //     //       name: 'Hospital',
  //     //     //       link: 'dashboards/healthcare/hospital'
  //     //     //     }
  //     //     //   ]
  //     //     // },
  //     //     // {
  //     //     //   name: 'Helpdesk',
  //     //     //   link: 'dashboards/helpdesk'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Learning',
  //     //     //   link: 'dashboards/learning'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Monitoring',
  //     //     //   link: 'dashboards/monitoring'
  //     //     // },
  //     //     // {
  //     //     //   name: 'Tasks',
  //     //     //   link: 'dashboards/tasks'
  //     //     // }
  //     //   ]
  //     // },
  //     {
  //       name: 'Informativos',
  //       icon: UploadFile,
  //       link: '/accent-sidebar/files',
  //     },
  //   ],
  // },
  {
    heading: 'Access Control',
    subject: 'role',
    items: [
      {
        name: 'Roles',
        icon: LockOpenTwoTone,
        link: '/accent-sidebar/access-control/roles',
        subject: 'role',
      },
    ],
  },
  {
    heading: 'Financial',
    subject: 'financial',
    items: [
      {
        name: 'Invoices',
        icon: ReceiptLongTwoTone,
        link: '/accent-sidebar/financial/invoice/list',
        subject: 'invoice',
      },
      {
        name: 'Receipts',
        icon: ReceiptTwoTone,
        link: '/accent-sidebar/financial/receipt/list',
        subject: 'receipt',
      },
      {
        name: 'Boletos',
        icon: RequestQuoteTwoTone,
        link: '/accent-sidebar/financial/boleto/list',
        subject: 'boleto',
      },
    ],
  },
  {
    heading: 'Files',
    subject: 'file',
    items: [
      {
        name: 'Files',
        icon: InsertDriveFileTwoTone,
        link: '/accent-sidebar/file',
        subject: 'file',
      },
    ],
  },
  {
    heading: 'Informative',
    subject: 'informative',
    items: [
      {
        name: 'Communicate',
        icon: ForumTwoTone,
        link: '/accent-sidebar/informative/communicate/list',
        subject: 'communicate',
      },
      {
        name: 'Email Templates',
        icon: EmailTwoTone,
        link: '/accent-sidebar/informative/email-templates/list',
        subject: 'email-template',
      },
      {
        name: 'Recipient Groups',
        icon: GroupTwoTone,
        link: '/accent-sidebar/informative/recipient-groups/list',
        subject: 'recipient-group',
      },
      {
        name: 'Recipients',
        icon: ContactMailTwoTone,
        link: '/accent-sidebar/informative/recipients/list',
        subject: 'recipient',
      },
    ],
  },

  {
    heading: 'Management',
    subject: 'user',
    items: [
      {
        name: 'Laboratory',
        icon: Biotech,
        link: '/accent-sidebar/management/laboratory/list',
        subject: 'laboratory',
        // items: [
        //   {
        //     name: t('List'),
        //     link: 'management/laboratory/list',
        //   },

        // ],
      },
      {
        name: 'Users',
        icon: AssignmentIndTwoTone,
        link: '/accent-sidebar/management/users/list',
        subject: 'user',
        // items: [
        //   {
        //     name: t('List'),
        //     link: 'management/users/list',
        //   },
        //   {
        //     name: t('User Profile'),
        //     link: 'management/users/single',
        //   },
        // ],
      },

      // {
      //   name: 'Projects',
      //   icon: AccountTreeTwoTone,
      //   link: '/accent-sidebar/management/projects/list',
      // },
      // {
      //   name: 'Commerce',
      //   icon: StorefrontTwoTone,
      //   link: '/accent-sidebar/management/commerce',
      //   items: [
      //     {
      //       name: 'Shop',
      //       link: 'management/commerce/shop',
      //     },
      //     {
      //       name: 'List',
      //       link: 'management/commerce/products/list',
      //     },
      //     {
      //       name: 'Details',
      //       link: 'management/commerce/products/single/1',
      //     },
      //     {
      //       name: 'Create',
      //       link: 'management/commerce/products/create',
      //     },
      //   ],
      // },
      // {
      //   name: 'Invoices',
      //   icon: ReceiptTwoTone,
      //   link: '/accent-sidebar/management/invoices',
      //   items: [
      //     {
      //       name: 'List',
      //       link: 'management/invoices/list',
      //     },
      //     {
      //       name: 'Details',
      //       link: 'management/invoices/single',
      //     },
      //   ],
      // },
    ],
  },
  // {
  //   heading: 'Extra Pages',
  //   items: [
  //     {
  //       name: 'Auth Pages',
  //       icon: VpnKeyTwoToneIcon,
  //       link: '/auth',
  //       items: [
  //         {
  //           name: 'Login',
  //           items: [
  //             {
  //               name: 'Basic',
  //               link: '/account/login-basic'
  //             },
  //             {
  //               name: 'Cover',
  //               link: '/account/login-cover'
  //             }
  //           ]
  //         },
  //         {
  //           name: 'Register',
  //           items: [
  //             {
  //               name: 'Basic',
  //               link: '/account/register-basic'
  //             },
  //             {
  //               name: 'Cover',
  //               link: '/account/register-cover'
  //             },
  //             {
  //               name: 'Wizard',
  //               link: '/account/register-wizard'
  //             }
  //           ]
  //         },
  //         {
  //           name: 'Recover Password',
  //           link: '/account/recover-password'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'Status',
  //       icon: ErrorTwoToneIcon,
  //       link: '/status',
  //       items: [
  //         {
  //           name: 'Error 404',
  //           link: '/status/404'
  //         },
  //         {
  //           name: 'Error 500',
  //           link: '/status/500'
  //         },
  //         {
  //           name: 'Maintenance',
  //           link: '/status/maintenance'
  //         },
  //         {
  //           name: 'Coming Soon',
  //           link: '/status/coming-soon'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   heading: 'Foundation',
  //   items: [
  //     {
  //       name: 'Overview',
  //       link: '/overview',
  //       icon: DesignServicesTwoToneIcon
  //     },
  //     {
  //       name: 'Documentation',
  //       icon: SupportTwoToneIcon,
  //       link: '/docs'
  //     }
  //   ]
  // }
];

export default menuItems;
